export * from "@vaadin/message-list/vaadin-message-list.js";
export * from './generated/MessageList.js';
